import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
    className?: string;
    children: ReactNode;
}

export function Card({ className, children }: Props) {
    return <div className={twMerge('flex flex-col rounded-lg bg-white shadow', className)}>{children}</div>;
}
